import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { isEmpty } from "helpers/Helpers";

interface IReadOnlyURLSearchParams extends URLSearchParams {
  append: never;
  set: never;
  delete: never;
  sort: never;
}

export function useUrlParams(defaultParams: Record<string, string>) {
  const history = useHistory();
  const { search } = useLocation();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  function setSearchParam(name: string, value: string) {
    const updatedParams = new URLSearchParams(window.location.search);
    updatedParams.set(name, value);
    history.replace({ search: updatedParams.toString() });
  }

  useEffect(() => {
    const updatedParams = new URLSearchParams(searchParams);

    Object.keys(defaultParams).forEach(name => {
      const value = defaultParams[name];

      if (isEmpty(updatedParams.get(name))) {
        updatedParams.set(name, value);
      }
    });

    history.replace({ search: updatedParams.toString() });
  }, []);

  return {
    searchParams: searchParams as IReadOnlyURLSearchParams,
    setSearchParam,
  };
}
